import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ProjectFilter } from '../components/ProjectFilter';
import { ProjectModal } from '../components/ProjectModal';
import { ArrowUpRight } from 'lucide-react';
const categories = ['All', 'Branding', 'Digital', 'Content', 'Motion', 'Photography'];
const projects = [{
  id: 1,
  title: 'Neon Horizon',
  category: 'Branding',
  year: '2023',
  image: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&w=800&q=80',
  height: 'h-[400px]'
}, {
  id: 2,
  title: 'Urban Decay',
  category: 'Photography',
  year: '2023',
  image: 'https://images.unsplash.com/photo-1493397212122-2b85dda8106b?auto=format&fit=crop&w=800&q=80',
  height: 'h-[600px]'
}, {
  id: 3,
  title: 'Future Tech',
  category: 'Digital',
  year: '2024',
  image: 'https://images.unsplash.com/photo-1519638399535-1b036603ac77?auto=format&fit=crop&w=800&q=80',
  height: 'h-[500px]'
}, {
  id: 4,
  title: 'Abstract Flow',
  category: 'Content',
  year: '2023',
  image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=800&q=80',
  height: 'h-[450px]'
}, {
  id: 5,
  title: 'Minimalist',
  category: 'Branding',
  year: '2024',
  image: 'https://images.unsplash.com/photo-1449247709967-d4461a6a6103?auto=format&fit=crop&w=800&q=80',
  height: 'h-[550px]'
}, {
  id: 6,
  title: 'Dark Matter',
  category: 'Motion',
  year: '2023',
  image: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=800&q=80',
  height: 'h-[400px]'
}, {
  id: 7,
  title: 'Cyber Punk',
  category: 'Digital',
  year: '2024',
  image: 'https://images.unsplash.com/photo-1535378437327-b71494669e80?auto=format&fit=crop&w=800&q=80',
  height: 'h-[480px]'
}, {
  id: 8,
  title: 'Vivid Dreams',
  category: 'Photography',
  year: '2023',
  image: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?auto=format&fit=crop&w=800&q=80',
  height: 'h-[520px]'
}, {
  id: 9,
  title: 'Sonic Wave',
  category: 'Motion',
  year: '2024',
  image: 'https://images.unsplash.com/photo-1514525253440-b393452e3726?auto=format&fit=crop&w=800&q=80',
  height: 'h-[420px]'
}, {
  id: 10,
  title: 'Eco System',
  category: 'Branding',
  year: '2023',
  image: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&w=800&q=80',
  height: 'h-[580px]'
}, {
  id: 11,
  title: 'Tech Noir',
  category: 'Digital',
  year: '2024',
  image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80',
  height: 'h-[460px]'
}, {
  id: 12,
  title: 'Urban Life',
  category: 'Content',
  year: '2023',
  image: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?auto=format&fit=crop&w=800&q=80',
  height: 'h-[500px]'
}];
export function Work() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedProject, setSelectedProject] = useState<(typeof projects)[0] | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const filteredProjects = activeCategory === 'All' ? projects : projects.filter(project => project.category === activeCategory);
  const handleProjectClick = (project: (typeof projects)[0]) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };
  return <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black" data-id="element-315">
      <Navigation data-id="element-316" />

      <main className="pt-32 pb-24 px-6" data-id="element-317">
        <div className="max-w-7xl mx-auto" data-id="element-318">
          {/* Header */}
          <div className="mb-16" data-id="element-319">
            <h1 className="text-6xl md:text-8xl font-black tracking-tighter mb-8" data-id="element-320">
              OUR <span className="text-yellow-400" data-id="element-321">WORK</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl leading-relaxed" data-id="element-322">
              A curated selection of our favorite projects. We help brands stand
              out through bold design and immersive digital experiences.
            </p>
          </div>

          {/* Filter */}
          <ProjectFilter categories={categories} activeCategory={activeCategory} onSelectCategory={setActiveCategory} data-id="element-323" />

          {/* Grid */}
          <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8" data-id="element-324">
            {filteredProjects.map(project => <div key={project.id} onClick={() => handleProjectClick(project)} className="group relative break-inside-avoid overflow-hidden cursor-pointer bg-gray-900" data-id="element-325">
                <div className={`w-full ${project.height} relative`} data-id="element-326">
                  <img src={project.image} alt={project.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-327" />

                  {/* Overlay */}
                  <div className="absolute inset-0 bg-yellow-400/95 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-between p-8" data-id="element-328">
                    <div className="flex justify-between items-start translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75" data-id="element-329">
                      <span className="text-black font-bold tracking-widest uppercase text-sm border border-black px-2 py-1" data-id="element-330">
                        {project.category}
                      </span>
                      <span className="text-black font-bold text-sm" data-id="element-331">
                        {project.year}
                      </span>
                    </div>

                    <div className="translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-100" data-id="element-332">
                      <h3 className="text-black text-4xl font-black uppercase tracking-tighter mb-4" data-id="element-333">
                        {project.title}
                      </h3>
                      <div className="flex items-center text-black font-bold uppercase tracking-wider text-sm group/link" data-id="element-334">
                        View Project
                        <ArrowUpRight className="ml-2 w-5 h-5 transition-transform group-hover/link:translate-x-1 group-hover/link:-translate-y-1" data-id="element-335" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </main>

      <ProjectModal project={selectedProject} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-336" />

      <Footer data-id="element-337" />
    </div>;
}